import { AuthorizationResourcesAndSubjects } from '@/types/authorization'

export type ModuleTypeOption = { label: string; value: string }

export const ALL_MODULE_TYPE_OPTIONS: ModuleTypeOption[] = [
  { label: 'Gestão de Escalas', value: 'schedule_management' },
  { label: 'Registro de Plantão', value: 'ds_attendance' },
  { label: 'Métricas de Satisfação', value: 'nps' },
  { label: 'Validação de Excepcionalidade', value: 'station_exceptionalities' },
  { label: 'Pós-Plantão', value: 'post_station' },
  { label: 'Documentação', value: 'professional_documents' }
]

/** Módulos que não existem no nível do recurso (D112: "Documentação" é só por empresa). */
const UNSUPPORTED_MODULES: Partial<Record<AuthorizationResourcesAndSubjects, Set<string>>> = {
  [AuthorizationResourcesAndSubjects.Schedule]: new Set([
    'nps',
    'post_station',
    'professional_documents'
  ]),
  [AuthorizationResourcesAndSubjects.HealthUnit]: new Set(['professional_documents'])
}

/** Módulos que o modal de compartilhamento oferece para o recurso base (Empresa, Unidade ou Escala). */
export const moduleTypeOptionsFor = (
  base: AuthorizationResourcesAndSubjects | undefined
): ModuleTypeOption[] => {
  const unsupported = base ? UNSUPPORTED_MODULES[base] : undefined
  return unsupported
    ? ALL_MODULE_TYPE_OPTIONS.filter((option) => !unsupported.has(option.value))
    : ALL_MODULE_TYPE_OPTIONS
}
